module.exports = __webpack_public_path__ + "img/sidebar_premier_league_challenge_202627.68c1216e.png";